export default __webpack_public_path__ + "static/media/about-work-search.a21582b0.png";